import {Entity} from './entity.model';

export class EntitiesTypes {
  name: string;
  display_name: string;
  main_color: string;
  text_color: string;

  constructor(name: string, display_name: string, main_color: string, text_color: string) {
    this.name = name;
    this.display_name = display_name;
    this.main_color = main_color;
    this.text_color = text_color;
  }
}

export class htmlDocument {
  id: string;
  name: string;
  content: string;
  entities: Entity[];
  numberOfPages: number;
  status: string;
  labels?: EntitiesTypes[];

  constructor(id: string, name: string, content: string, entities: Entity[], numberOfPages: number, status?: string) {
    this.id = id;
    this.name = name;
    this.content = content;
    this.entities = entities;
    this.numberOfPages = numberOfPages;
    this.status = status;
  }
}

export class editHtmlDocument {
  document: htmlDocument;
  unSavedChanges: boolean;

  constructor(document: htmlDocument, unSavedChanges: boolean) {
    this.document = document;
    this.unSavedChanges = unSavedChanges;
  }
}
